import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../utils/styledComponent';
import theme from '../../theme';

const StyledButton = styledComponent('button', {
  color: theme.colors.text,
  padding: theme.spacing.dropdownItemPadding,
  display: 'block',
  width: '100%',
  cursor: 'pointer',
  ...theme.typography.label,
  background: 'none',
  border: 'none',
  textAlign: 'left',
  borderBottom: theme.borders.card,
  '&:last-child': {
    borderBottom: 'none',
  },
  '&:hover': {
    background: theme.colors.bgMuted,
  },

  '& .dropdown-item-hint': {
    ...theme.typography.hint,
    color: theme.colors.textMuted,
    marginTop: theme.spacing.gapXs,
  },
});

function DropdownItem({ label, hint, onClick }) {
  return (
    <StyledButton type="button" onClick={onClick}>
      <div>{label}</div>
      {hint && <div className="dropdown-item-hint">{hint}</div>}
    </StyledButton>
  );
}

DropdownItem.propTypes = {
  label: PropTypes.string.isRequired,
  hint: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

DropdownItem.defaultProps = {
  hint: null,
};

export default DropdownItem;
